export default {
  form: {
    tax_id: {
      label: 'Belastingnummer',
      placeholder: 'Belastingnummer invoeren',
    },
    has_vat: {
      label: 'Is uw bedrijf btw-plichtig?',
    },
    vat_id: {
      label: 'Btw',
      placeholder: 'Btw',
      tooltip: 'Een btw-nummer is een uniek belastingnummer dat uw bedrijf identificeert',
    },
    tax_percentage: {
      label: 'Belastingpercentage',
      placeholder: 'Belastingpercentage',
    },
    has_dedicated_products_tax: {
      label: 'Belasting % verschilt per product',
    },
  },
  buttons: {
    next: 'Volgende',
    back: 'Terug',
    skip: 'Overslaan',
  },
};
